import type React from "react";
import CompanySidebar from "../components/layouts/company-sidebar.tsx";

export interface CompanyLayoutProps {
    children?: React.ReactNode;
}

const CompanyLayout = ({ children }: CompanyLayoutProps) => {
    return <CompanySidebar>{children}</CompanySidebar>;
};

export default CompanyLayout;
